import { createFileRoute } from '@tanstack/react-router';

import { ForgotPassword, forgotPasswordSearchSchema } from 'features/auth/ForgotPassword';

export const Route = createFileRoute('/auth/_auth/forgot-password/')({
  component: ForgotPasswordRoute,
  validateSearch: forgotPasswordSearchSchema
});

function ForgotPasswordRoute() {
  const { email, error } = Route.useSearch();

  return <ForgotPassword error={error} prefillEmail={email} />;
}
